<!--
  Author: Jake G. | Vesper Cloud Solutions
  Copyright (c) 2025
-->
<div class="bg-(--toolbar-color) text-(--toolbar-text-color) relative">
  <!-- Logo is pinned flush to the viewport edge, deliberately outside the
       container below. -->
  <a routerLink="/" class="absolute left-0 top-0 z-10" aria-label="Home" i18n-aria-label="@@homeLabel">
    <img src="assets/images/HoganLogo.jpg" alt="Hogan Logo" class="h-9 sm:h-[50px] w-auto" i18n-alt="@@logoAlt" />
  </a>
  <!-- Same container as the page content, so the icons line up with the right
       edge of the project cards. Left padding always clears the pinned logo:
       reclaiming it only on very wide screens would slide the client selector
       sideways at a breakpoint, which reads worse than a consistent offset. -->
  <div
    class="w-full max-w-6xl mx-auto pr-4 pl-[92px] sm:pl-[132px] flex flex-row items-center gap-x-2 min-h-[50px]">
    <div class="grow min-w-0 flex flex-row items-center">
    @if(this.clients){ <app-client-selector (clientChanged)="setActiveClient($event)" [clients]="clients"
      class="grow min-w-0 flex items-center space-x-2" /> }@else{ <span class="grow min-w-0 flex items-center space-x-2"></span> }
    <div class="flex items-center search-wrapper">
      <div class="search-container" [class.open]="searchOpen()">
        <input #searchInput type="text" class="search-input" placeholder="Search" i18n-placeholder
          (input)="onSearchInput($event)" (keydown.enter)="submitSearch()" (blur)="submitSearch()" />
        <button type="button" class="search-go" (mousedown)="submitSearch()" i18n>Go</button>
      </div>
      <button matIconButton class="search-button" aria-label="Search" i18n-aria-label="@@searchLabel"
        (click)="toggleSearch(searchInput)">
        <mat-icon class="text-xs" fontIcon="search"></mat-icon>
      </button>
    </div>
    <button matIconButton aria-label="Help" [matMenuTriggerFor]="menu" i18n-aria-label="@@helpLabel">
      <mat-icon fontIcon="help_outline"></mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <a mat-menu-item i18n-aria-label aria-label="User Guide" href="/HaloLiteUserGuide.pdf" target="_blank"
        rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">quick_reference_all</mat-icon>
        <span i18n>User Guide</span>
      </a>
      @if (policyUrl) {
      <a mat-menu-item i18n-aria-label aria-label="Hogan Privacy Policy" [href]="policyUrl" target="_blank"
        rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">visibility</mat-icon>
        <span i18n>Hogan Privacy Policy</span>
      </a>
      } @if (termsUrl) {
      <a mat-menu-item i18n-aria-label aria-label="Terms of Use" [href]="termsUrl" target="_blank" rel="noopener">
        <mat-icon aria-hidden="true" fontSet="material-symbols-outlined">text_ad</mat-icon>
        <span i18n>Terms of Use</span>
      </a>
      }
    </mat-menu>
    <button matIconButton aria-label="Exit" (click)="logout()" i18n-aria-label="@@exitLabel">
      <mat-icon fontIcon="logout"></mat-icon>
    </button>
    </div>
  </div>
</div>
<main [class.opacity-0]="isNavigating()" class="transition-opacity duration-250 ease-in-out">
  <router-outlet></router-outlet>
</main>
<div [class.hidden]="!isNavigating()"
  class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) opacity-95 z-2"></div>
<div [class.hidden]="!isNavigating()"
  class="fixed inset-0 flex flex-col items-center justify-center gap-10 z-3 px-4 text-center">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  <div class="text-white text-3xl">
    Loading...
  </div>
</div>